import React from "react";
import {
  Typography,
  Link,
  Grid,
  Box,
  Button,
  Stack,
  Card,
  CardContent,
  CardActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Intro from "../../../components/atoms/Intro/Intro.component";
import Content from "../../../components/layout/pageLayout/Content/Content.component";
import DoneIcon from "@mui/icons-material/Done";
import { deleteEntireCart } from "../../../helpers";
import { convertToPlaces } from "../../../helpers/helpers";

const CustomerStoreCheckoutSucces = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { invoice } = location.state || {}; // Get the invoice from the state

  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/">
      Store
    </Link>,
    <Typography key="2">Cart</Typography>,
    <Typography key="3">Success</Typography>,
  ];

  return (
    <>
      <Intro
        pageTitle={`Success`}
        pageTitleShort="Store"
        breadcrumbs={breadcrumbs}
        additionalWidgets=""
      />

      <Content>
        <Grid container>
          <Grid item xs={12} sm={8} md={6} sx={{ mx: "auto", textAlign: "center" }}>
            <Card>
              <CardContent sx={{ p: 5 }}>
                <Box
                  sx={{
                    background: "#12830b",
                    width: 75,
                    height: 75,
                    borderRadius: "50%",
                    mx: "auto",
                    display: "block",
                  }}
                >
                  <DoneIcon
                    sx={{
                      color: "#fff",
                      fontSize: 40,
                      mt: 2,
                    }}
                  />
                </Box>
                <Typography variant="h5" sx={{ mt: 1, mb: 1 }}>
                  Your Order has been placed successfully!
                </Typography>

                <Typography color="text.secondary" gutterBottom>
                  We received your order and you will receive an invoice to
                  complete your payment.
                </Typography>

                {/* <Box sx={{ px: { xs: 2, sm: 10 }, mt: 5 }}>
                  <Typography
                    color="text.secondary"
                    gutterBottom
                    variant="body2"
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <span>Payment Status</span>
                      <span style={{ flex: 1 }}></span>
                      <strong>Pending</strong>
                    </Stack>
                  </Typography>
                  <Typography
                    color="text.secondary"
                    gutterBottom
                    variant="body2"
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <span>Invoice ID</span>
                      <span style={{ flex: 1 }}></span>
                      <strong>{invoice ? `#${invoice.id}` : "N/A"}</strong>
                    </Stack>
                  </Typography>
                </Box> */}

                {/* Sales Order Items Table for Reseller */}
                {invoice?.is_reseller === 1 && invoice?.items?.length > 0 && (
                  <Box sx={{ mt: 5, textAlign: "left" }}>
                    <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
                      Order Items
                    </Typography>
                    <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Style</TableCell>
                            <TableCell align="right">Qty</TableCell>
                            <TableCell align="right">Unit Price</TableCell>
                            <TableCell align="right">Total Price</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {invoice.items.map((item, idx) => (
                            <TableRow key={item.id || idx}>
                              <TableCell>{item.style || '-'}</TableCell>
                              <TableCell align="right">{item.qty}</TableCell>
                              <TableCell align="right">
                                {convertToPlaces(item.unit_price || 0)}
                              </TableCell>
                              <TableCell align="right">
                              {convertToPlaces(item.total_price || 0)}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
                {/* End Sales Order Items Table */}
              </CardContent>
              <CardActions>
                <Button
                  size="small"
                  sx={{ mx: "auto" }}
                  onClick={() => {
                    deleteEntireCart();
                    navigate("/store");
                  }}
                >
                  Back to Store
                </Button>
                {(invoice && invoice?.is_reseller !== 1) && (
                  <Button
                    size="small"
                    sx={{ mx: "auto" }}
                    onClick={() =>
                      navigate(`/admin/invoice/${invoice.id}/customer`)
                    }
                  >
                    Go to Invoice
                  </Button>
                )}
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Content>
    </>
  );
};

export default CustomerStoreCheckoutSucces;
